module.exports = {"id":"159240","name":"Michael Krohn-Dehli","rating":"77","photo":"./data/images/photos/2/159240.png","club":{"name":"Deportivo","logo":"./data/images/clubs/Deportivo.png"},"positions":["MG","MC","MOC","MDC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MichaelKrohn-Dehli0.json
// module id = 2988
// module chunks = 0